module.exports = __webpack_public_path__ + "static/media/TRANSTORNO.1a7d47ab.png";